import React from 'react'

import css from './style.scss'

// Colour is never the only signal — the chips carry visually hidden prefixes
// saying the same thing — but the legend makes the visual coding legible.
const CalendarLegend = () => (
  <ul className={css.legend}>
    <li className={css.legendItem}>
      <span className={`${css.legendSwatch} ${css.chipWebinar}`} aria-hidden='true' />
      Live event
    </li>
    <li className={css.legendItem}>
      <span className={`${css.legendSwatch} ${css.chipDeadline}`} aria-hidden='true' />
      Registration closes
    </li>
  </ul>
)

export default CalendarLegend
